import services from '@/service';

export default {
  state: {
    mallId: '',
    mallInfo: {},
    curClinicId: localStorage.getItem('curClinicId') || null,
    curClinicName: localStorage.getItem('curClinicName') || ''
  },
  getters: {
    mallId: state => state.mallId,
    mallInfo: state => state.mallInfo,
    curClinicId: state => state.curClinicId,
    curClinicName: state => state.curClinicName
  },
  actions: {
    set_mallId({ commit }, value) {
      commit('set_mallId', value);
    },
    async set_mallInfo({ commit }) {
      const { data } = await services.mall.getMallInfo();
      commit('set_mallInfo', data);
    },
    set_curClinicId({ commit }, value) {
      commit('set_curClinicId', value);
    },
    set_curClinicName({ commit }, value) {
      commit('set_curClinicName', value);
    }
  },
  mutations: {
    set_mallId(state, value) {
      state.mallId = value;
    },
    set_mallInfo(state, value) {
      state.mallInfo = value;
      state.mallId = value.userRelId;
    },
    set_curClinicId(state, value) {
      state.curClinicId = value;
      localStorage.setItem('curClinicId', value);
    },
    set_curClinicName(state, value) {
      state.curClinicName = value;
      localStorage.setItem('curClinicName', value);
    }
  }
};
